import { deleteWallet, updateWallet } from '../../api/wallets.js';
import { saveTransactionToDB } from '../../api/transactions.js';
import { showToast } from '../../utils/toast.js';

let currentWallet = null; // Lưu full wallet object (id, name, balance, currency)

export function initWalletDetailModal() {
    const modal = document.getElementById('wallet-detail-modal');
    const content = document.getElementById('wallet-detail-content');
    const btnClose = document.getElementById('btn-close-wallet-detail');
    const btnDelete = document.getElementById('btn-wallet-delete');
    const btnRename = document.getElementById('btn-wallet-rename');
    const btnAdjust = document.getElementById('btn-wallet-adjust');

    // Rename UI elements
    const renameBar     = document.getElementById('wallet-rename-bar');
    const renameInput   = document.getElementById('wallet-rename-input');
    const btnRenameSave = document.getElementById('btn-wallet-rename-save');
    const btnRenameCancel = document.getElementById('btn-wallet-rename-cancel');

    // Adjust Balance UI elements
    const adjustBar       = document.getElementById('wallet-adjust-bar');
    const adjustInput     = document.getElementById('wallet-adjust-input');
    const adjustDiff      = document.getElementById('wallet-adjust-diff');
    const btnAdjustSave   = document.getElementById('btn-wallet-adjust-save');
    const btnAdjustCancel = document.getElementById('btn-wallet-adjust-cancel');

    if (!modal) return;

    function hideAllBars() {
        renameBar?.classList.add('hidden');
        adjustBar?.classList.add('hidden');
        if (renameInput) renameInput.value = '';
        if (adjustInput) adjustInput.value = '';
    }

    // Mở modal
    window.addEventListener('openWalletDetail', (e) => {
        currentWallet = e.detail;
        hideAllBars();

        document.getElementById('detail-wallet-name').innerText = currentWallet.name;
        document.getElementById('detail-wallet-balance').innerText = Number(currentWallet.balance).toLocaleString('en-US');
        document.getElementById('detail-wallet-currency').innerText = currentWallet.currency;

        modal.classList.remove('hidden');
        modal.classList.add('flex');
        setTimeout(() => {
            content.classList.remove('translate-y-full');
            content.classList.add('translate-y-0');
        }, 10);
    });

    // Đóng Modal
    const closeModal = () => {
        content.classList.remove('translate-y-0');
        content.classList.add('translate-y-full');
        hideAllBars();
        setTimeout(() => {
            modal.classList.add('hidden');
            modal.classList.remove('flex');
        }, 300);
    };

    btnClose.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });

    // ---- RENAME ----
    btnRename?.addEventListener('click', () => {
        hideAllBars();
        renameInput.value = currentWallet.name;
        renameBar.classList.remove('hidden');
        renameInput.focus();
    });

    btnRenameCancel?.addEventListener('click', () => renameBar.classList.add('hidden'));

    btnRenameSave?.addEventListener('click', async () => {
        const newName = renameInput.value.trim();
        if (!newName || newName === currentWallet.name) { renameBar.classList.add('hidden'); return; }

        btnRenameSave.innerText = 'Saving...'; btnRenameSave.disabled = true;
        const updated = await updateWallet(currentWallet.id, newName);
        btnRenameSave.innerText = 'Save'; btnRenameSave.disabled = false;

        if (updated) {
            currentWallet.name = newName;
            document.getElementById('detail-wallet-name').innerText = newName;
            renameBar.classList.add('hidden');
            showToast('Wallet renamed!', 'success');
            if (window.refreshAllActiveViews) window.refreshAllActiveViews();
        } else {
            showToast('Failed to rename wallet', 'error');
        }
    });

    renameInput?.addEventListener('keydown', (e) => { if (e.key === 'Enter') btnRenameSave.click(); });

    // ---- ADJUST BALANCE ----
    btnAdjust?.addEventListener('click', () => {
        hideAllBars();
        adjustInput.value = Number(currentWallet.balance).toLocaleString('en-US');
        adjustDiff.innerText = '';
        adjustBar.classList.remove('hidden');
        adjustInput.focus();
    });

    adjustInput?.addEventListener('input', () => {
        const actualStr = adjustInput.value.replace(/,/g, '');
        const actual = Number(actualStr);
        if (isNaN(actual)) { adjustDiff.innerText = ''; return; }
        const diff = actual - Number(currentWallet.balance);
        if (diff === 0) {
            adjustDiff.className = 'text-xs text-gray-400 mt-1';
            adjustDiff.innerText = 'No change';
        } else if (diff > 0) {
            adjustDiff.className = 'text-xs text-income font-bold mt-1';
            adjustDiff.innerText = `+${diff.toLocaleString('en-US')} ${currentWallet.currency} (income adjustment)`;
        } else {
            adjustDiff.className = 'text-xs text-expense font-bold mt-1';
            adjustDiff.innerText = `${diff.toLocaleString('en-US')} ${currentWallet.currency} (expense adjustment)`;
        }
    });

    adjustInput?.addEventListener('blur', () => {
        const val = adjustInput.value.replace(/,/g, '');
        if (val) adjustInput.value = Number(val).toLocaleString('en-US');
    });

    adjustInput?.addEventListener('focus', () => {
        adjustInput.value = adjustInput.value.replace(/,/g, '');
    });

    btnAdjustCancel?.addEventListener('click', () => adjustBar.classList.add('hidden'));

    btnAdjustSave?.addEventListener('click', async () => {
        const actualStr = adjustInput.value.replace(/,/g, '');
        const actual = Number(actualStr);
        if (isNaN(actual) || actual < 0) { showToast('Invalid amount', 'error'); return; }

        const diff = actual - Number(currentWallet.balance);
        if (diff === 0) { adjustBar.classList.add('hidden'); return; }

        btnAdjustSave.innerText = 'Saving...'; btnAdjustSave.disabled = true;

        const txnType = diff > 0 ? 'income' : 'expense';
        const txnData = {
            type: txnType,
            amount: Math.abs(diff),
            currency: currentWallet.currency,
            base_amount: Math.abs(diff),
            exchange_rate: 1,
            wallet_id: currentWallet.id,
            category_id: null,
            tag_id: null,
            category_name: 'Balance Adjustment',
            tag_name: null,
            remark: `Manual balance adjustment (${Number(currentWallet.balance).toLocaleString('en-US')} → ${actual.toLocaleString('en-US')})`,
            transaction_date: new Date().toISOString().split('T')[0],
        };

        const saved = await saveTransactionToDB(txnData);
        btnAdjustSave.innerText = 'Apply'; btnAdjustSave.disabled = false;

        if (saved) {
            currentWallet.balance = actual;
            document.getElementById('detail-wallet-balance').innerText = actual.toLocaleString('en-US');
            adjustBar.classList.add('hidden');
            showToast('Balance adjusted successfully!', 'success');
            if (window.refreshAllActiveViews) window.refreshAllActiveViews();
        } else {
            showToast('Failed to adjust balance', 'error');
        }
    });

    // ---- DELETE ----
    const confirmModal = document.getElementById('confirm-wallet-modal');
    const btnConfirmCancel = document.getElementById('btn-wallet-confirm-cancel');
    const btnConfirmOk = document.getElementById('btn-wallet-confirm-ok');

    btnDelete.addEventListener('click', () => {
        if (!currentWallet?.id) return;
        closeModal();
        setTimeout(() => {
            confirmModal.classList.remove('hidden');
            confirmModal.classList.add('flex');
        }, 300);
    });

    btnConfirmCancel.addEventListener('click', () => {
        confirmModal.classList.add('hidden');
        confirmModal.classList.remove('flex');
    });

    btnConfirmOk.addEventListener('click', async () => {
        if (!currentWallet?.id) return;

        btnConfirmOk.innerHTML = '<i class="fa-solid fa-spinner fa-spin mr-2"></i>Deleting...';
        btnConfirmOk.disabled = true;

        const isSuccess = await deleteWallet(currentWallet.id);
        if (isSuccess) {
            showToast('Wallet hidden successfully', 'success');
            confirmModal.classList.add('hidden');
            confirmModal.classList.remove('flex');
            if (window.refreshAllActiveViews) window.refreshAllActiveViews();
        } else {
            showToast('Failed to delete wallet', 'error');
        }

        btnConfirmOk.innerHTML = 'Yes, Delete';
        btnConfirmOk.disabled = false;
        currentWallet = null;
    });
}
